export const baseURLIdentifiers = {
    AUTH_SERVICE: 'authService',
    PRODUCT_SERVICE: 'productService',
    ORDER_SERVICE: 'orderService',
    USER_SERVICE: 'userService'
}